/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S12_Li2_DescInputs */

const tr_iade_iptal_s12_li2_desc = /** @type {(inputs: Iade_Iptal_S12_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belirli bir modül için yapılmış tek seferlik ödemeler (örn. ek depolama, kurulum hizmeti) iadesizdir; ancak Sağlayıcı kaynaklı hizmet kesintisi halinde pro-rata iade yapılır.`)
};

const en_iade_iptal_s12_li2_desc = /** @type {(inputs: Iade_Iptal_S12_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-off payments made for a specific module (e.g. additional storage, setup service) are non-refundable; however, a pro-rata refund is made in the event of a service interruption caused by the Provider.`)
};

const de_iade_iptal_s12_li2_desc = /** @type {(inputs: Iade_Iptal_S12_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmalzahlungen für ein bestimmtes Modul (z.B. zusätzlicher Speicher, Einrichtungsdienst) sind nicht erstattungsfähig; bei einer vom Anbieter verursachten Dienstunterbrechung erfolgt jedoch eine anteilige Erstattung.`)
};

const ru_iade_iptal_s12_li2_desc = /** @type {(inputs: Iade_Iptal_S12_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разовые платежи за определённый модуль (например, дополнительное хранилище, услуга установки) не подлежат возврату; однако при перерыве в обслуживании по вине Поставщика производится пропорциональный возврат.`)
};

/**
* | output |
* | --- |
* | "One-off payments made for a specific module (e.g. additional storage, setup service) are non-refundable; however, a pro-rata refund is made in the event of a..." |
*
* @param {Iade_Iptal_S12_Li2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s12_li2_desc = /** @type {((inputs?: Iade_Iptal_S12_Li2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S12_Li2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s12_li2_desc(inputs)
	if (locale === "de") return de_iade_iptal_s12_li2_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s12_li2_desc(inputs)
	return tr_iade_iptal_s12_li2_desc(inputs)
});